import { Component, OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../../services/constants"
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-post-job",
  templateUrl: "./post-job.component.html",
  styleUrls: ["./post-job.component.css"]
})
export class PostJobComponent implements OnInit {
  jobType = 1;
  allJobs:any=[];
  currentPage=1;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  // sorting
  sortType: any;
  sortBy : string = ""
  orderBy: string = "2";
  search="";
  type="useOldTemplate";
  closeSearch  :boolean = false;
  showError : boolean = false;
  disabled : boolean = false;
  selectedId:any;
  userDatas;
  constructor(public route: ActivatedRoute, private router: Router,private api: AdminService, private userDetailsService: UserDetailsService, private toastrService: ToastrService) {
    this.userDetailsService.getRecruiterUserData();
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDatas = userData;
    });
   }

  ngOnInit(): void {
    this.getJobs()
  }
  
  reDirectTo(){
    if(this.userDatas.companyPayment?.jobsCreadits > this.userDatas.companyPayment?.companyPostedJob){
      this.router.navigate(["/jobs/add"])
    } else{
      this.toastrService.error("", "Currently you don't have any subscription plan please buy the plan first.");
    }
  }
  getJobs(){
    this.api.stopLoader(); 
    let params = new HttpParams(); 
    params = params.append("skip", this.currentPage);
    params = params.append("limit", this.pagination.limit.toString());
    params = params.append("isConfirm", 1);
    if (this.search != null && this.search != "") {
      params = params.append("search", this.search);
    }
    if (this.sortBy) {
      params = params.append(
        "sortBy",
        this.sortBy.trim() ? this.sortBy.trim() : ""
      );
      params = params.append("orderBy", this.orderBy == "ASC" ? "ASC" : "DESC");
    }
    this.api.getData(apiUrl._getJobsListing,params)
    .subscribe(async (res) => {
      this.pagination.totalItems = res.data.count; 
      this.allJobs = res.data.listing;  
    })
  }
  checkListData(){
    if(this.allJobs == 0){
      this.disabled = true;
      this.toastrService.error("", "Please create a job first. You will be able to use it as a template in future.");
      return
    }
  }
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getJobs();
  }
  searchFun() {  
    this.currentPage = 1;
    this.pagination.skip = 0; 
    this.closeSearch = true; 
    this.getJobs(); 
    }
  clearSearch() {
    this.search= "";
    this.closeSearch = false;
    this.pagination.skip = 0; 
    localStorage.removeItem("type-redirect");
    this.getJobs(); 
  }
  selectedType(event, number){
    if(number == 0){
      this.jobType = 0
    } else{
      this.jobType = 1;
    }
  }

  selectJobId(id,i,event){
    this.selectedId = id;
    this.allJobs.map((emp)=>{
      emp["selected"] = false
      event.srcElement.classList.remove("selected")
    })
    this.allJobs[i]["selected"] = true
    event.srcElement.classList.add("selected")
  }
  redirectTo(){
    if(this.selectedId == "" || this.selectedId == undefined){
      this.showError = true;
      setTimeout(() => {
        this.showError = false;
      }, 1000);
      return
    } else{
      let queryparams = {}
      queryparams["useOldTemplate"] = this.type;
      this.router.navigate(["/jobs/template/" + this.selectedId], {queryParams : queryparams})
    }
  }
}
